type TokensDto = { accessToken: string; refreshToken: string };

export class Tokens implements TokensDto {
  private static readonly _tokensStorageKey = "authToken";
  public readonly accessToken: string;
  public readonly refreshToken: string;

  protected constructor(obj: { accessToken: string; refreshToken: string }) {
    const { accessToken, refreshToken } = obj;
    this.refreshToken = refreshToken;
    this.accessToken = accessToken;
  }

  public static create(obj: {
    accessToken: string;
    refreshToken: string;
  }): Tokens {
    return new Tokens(obj);
  }

  public static fromDto(dto: TokensDto): Tokens {
    return Tokens.create({ ...dto });
  }

  public static retrieveFromLocalStorage(
    key: string = Tokens._tokensStorageKey,
    throwIfNull?: boolean,
  ): Tokens | null {
    const tokens = localStorage.getItem(key);
    if (!tokens && throwIfNull) {
      throw new Error("Tokens could not be found by key");
    }

    return tokens ? Tokens.fromDto(JSON.parse(tokens)) : null;
  }

  public persist(key: string = Tokens._tokensStorageKey): void {
    localStorage.setItem(key, this.json);
  }

  public static destroy(key: string = Tokens._tokensStorageKey): void {
    localStorage.removeItem(key);
  }

  public get json(): string {
    return JSON.stringify({
      accessToken: this.accessToken,
      refreshToken: this.refreshToken,
    });
  }

  public isExpired(checkRefresh = false): boolean {
    const decodedToken = this.decodeToken(
      checkRefresh ? this.refreshToken : this.accessToken,
    );

    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime;
  }

  public isExpiredWithBuffer(
    bufferSeconds = 30,
    checkRefresh = false,
  ): boolean {
    const decodedToken = this.decodeToken(
      checkRefresh ? this.refreshToken : this.accessToken,
    );

    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime + bufferSeconds;
  }

  private decodeToken(token: string): { exp: number } {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    return JSON.parse(jsonPayload);
  }
}
